import React, { useEffect } from "react";

const CustomAlert = ({ message, onClose, autoClose = true, delay = 5000 }) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [autoClose, delay, onClose]);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="bg-white border rounded p-4 shadow-lg text-center"
        style={{ maxWidth: "400px", width: "90%" }}
      >
        <p className="fs-5 fw-semibold mb-4">{message}</p>
        <button className="btn btn-primary px-4" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
